import React from 'react';
import { getUnsafeGlobalInstance } from './unsafeGlobalInstance';

type Props = {
  readonly children?: React.ReactNode;
};

export function Providers({ children }: Props) {
  const Providers = getUnsafeGlobalInstance('providers');

  return <Providers>{children}</Providers>;
}
